export const TONNES_TO_KG = 1000
